import {consoleLogger} from '@gongxigames/framework/core';

export class Xhr {

    public static CONNECTION_TIMEOUT = 30000;

    public static get(url: string, cb: Function, headers?: any, fields?: any, onError?: Function): XMLHttpRequest {

        url = Xhr.addFieldsToURL(url, fields);

        return this.request(url, 'GET', 'json', null, headers, cb, onError);
    }

    public static addFieldsToURL(url: string, fields: any): string {
        if (url.indexOf('?') > 0) {
            url += '&';
        } else {
            url += '?';
        }
        url += Xhr.objectToKeyValue(fields);

        return url;
    }

    public static objectToKeyValue(object: any): string {
        return Object
            .entries(object || {})
            .sort((a, b) => a[0] > b[0] ? 1 : -1)
            .map(param => param.join('='))
            .join('&');
    }

    public static postWithFields(url: string, data: any, cb: Function, headers?: any, fields?: any, onError?: Function): XMLHttpRequest {
        url = Xhr.addFieldsToURL(url, fields);

        return this.request(url, 'POST', 'json', data, headers, cb, onError);
    }

    public static post(url: string, data: any, cb: Function, headers?: any, onError?: Function): XMLHttpRequest {
        return this.request(url, 'POST', 'json', data, headers, cb, onError);
    }

    public static put(url: string, data: any, cb: Function, headers?: any, onError?: Function): XMLHttpRequest {
        return this.request(url, 'PUT', 'json', data, headers, cb, onError);
    }

    public static delete(url: string, data: any, cb: Function, headers?: any, onError?: Function): XMLHttpRequest {
        return this.request(url, 'DELETE', 'json', data, headers, cb, onError);
    }

    public static request(url: string, method: 'GET' | 'POST' | 'DELETE' | 'PUT', type: XMLHttpRequestResponseType = 'json',
        data: any, headers?: any, onLoad?: Function, onError?: Function): XMLHttpRequest {
        const xhr = new XMLHttpRequest();

        xhr.open(method, url, true);
        xhr.responseType = type;

        headers && this.addHeaders(headers, xhr);

        xhr.onload = () => {
            try {
                // handle HTTP status codes of 4xx and 5xx as errors, even if xhr.onerror was not called
                if (xhr.readyState === 4 && xhr.status >= 400 && xhr.status <= 599) {
                    consoleLogger.warn(`Get request error. Status ${xhr.status}`);

                    return onError && onError(xhr);
                } else {
                    let response = xhr.response;

                    // IE doesn't parse json
                    if (type === 'json') {
                        if (typeof response === 'string') {
                            response = JSON.parse(response);
                        }
                    }

                    onLoad && onLoad(response);
                }
            } catch (e) {
                onError && onError(xhr);
                consoleLogger.error(e);
            }
        };
        xhr.timeout = Xhr.CONNECTION_TIMEOUT;
        xhr.ontimeout = () => {
            onError && onError(xhr, true);
        };

        xhr.onerror = () => {
            onError && onError(xhr);
        };

        xhr.send(data);

        return xhr;
    }

    public static addHeaders(headers: any, xhr: XMLHttpRequest): void {
        for (const key in headers) {
            if (headers.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
    }
}
